import React, { useEffect } from "react";
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist";

// Setting the worker source to a CDN
GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js`;

interface PdfViewerProps {
  pdfUrl: string; // Optional prop
  numPages: number;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ pdfUrl, numPages }) => {
  useEffect(() => {
    const loadPdf = async () => {
      try {
        // Loading the PDF document
        const pdf = await getDocument(pdfUrl).promise;
        for (let i = 1; i <= numPages; i++) {
          const page = await pdf.getPage(i);
          
          const canvas = document.getElementById(`canvas${i}`) as HTMLCanvasElement;
          if (canvas) {
            const context = canvas.getContext("2d");

            if (context) {
              const devicePixelRatio = window.devicePixelRatio || 1;
              const textViewport = page.getViewport({ scale:3 });
              canvas.width = textViewport.width * devicePixelRatio;
              canvas.height = textViewport.height * devicePixelRatio;
              context.scale(devicePixelRatio, devicePixelRatio);
    
              context.fillStyle = "white";
              context.fillRect(0, 0, canvas.width, canvas.height);
    
              const textRenderContext = {
                canvasContext: context,
                viewport: textViewport,
              };
              await page.render(textRenderContext);

              const imageViewport = page.getViewport({ scale: 3 });
          const offscreenCanvas = document.createElement("canvas");
          const offscreenContext = offscreenCanvas.getContext("2d");

          if (offscreenContext) {
            offscreenCanvas.width = imageViewport.width * devicePixelRatio;
            offscreenCanvas.height = imageViewport.height * devicePixelRatio;
            offscreenContext.scale(devicePixelRatio, devicePixelRatio);

            // Render images on the offscreen canvas
            const imageRenderContext = {
              canvasContext: offscreenContext,
              viewport: imageViewport,
            };
            await page.render(imageRenderContext);
            context.drawImage(
              offscreenCanvas,
              0,
              0,
              canvas.width / devicePixelRatio,
              canvas.height / devicePixelRatio
            );
          }
          const containerWidth = window.innerWidth * 0.7;
          const aspectRatio = textViewport.height / textViewport.width;
          const displayHeight = containerWidth * aspectRatio;

          canvas.style.width = `${containerWidth}px`;
          canvas.style.height = `${displayHeight}px`;
            } else {
              console.error("Failed to get canvas context");
            }
          } else {
            console.error("Canvas is null");
          }
        }
      } catch (error) {
        console.error("Error loading PDF:", error);
      }
    };

    if (pdfUrl && numPages) loadPdf();
  }, [pdfUrl, numPages]);

  return (
    <div
      style={{
       height: "80vh",         
      width: "100%",
      overflowY: "auto",       
      overflowX: "hidden",   
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      }}
    >
      {numPages > 0 && (
        <>
          {
            // Create an array to hold the <canvas> elements
            (() => {
              const canvases = [];
              for (let i = 1; i <= numPages; i++) {
                canvases.push(<canvas key={i} id={`canvas${i}`} />);
              }
              return canvases;
            })()
          }
        </>
      )}
    </div>
  );
};

export default PdfViewer;
